export default "__VITE_ASSET__B_Db7GkD__"